import styled, { css } from "styled-components";

import { ACCORDION_TRANSITION_TIMING } from "./utils";

export const CustomizedCollapsableComponent = styled.div<{
  $isAccordionOpen: boolean;
  $componentExpandedHeight: number;
  $componentCollapsedHeight: number;
}>`
  text-align: start;
  word-break: break-word;
  white-space: pre-wrap;
  width: 100%;
  overflow: hidden;
  ${({
    $isAccordionOpen,
    $componentExpandedHeight,
    $componentCollapsedHeight,
  }) =>
    $isAccordionOpen
      ? css`
          max-height: ${$componentExpandedHeight}px;
        `
      : css`
          max-height: ${$componentCollapsedHeight}px;
        `}
  transition-property: max-height;
  ${ACCORDION_TRANSITION_TIMING}
`;
